import React, { useState, useContext, useCallback, useRef } from "react";
import {
  View,
  FlatList,
  TouchableWithoutFeedback,
  ImageBackground,
  Dimensions,
  StyleSheet,
  Image,
} from "react-native";
import { useAssets } from "presto-react-components";
import GalleryManager from "@presto-services/features/gallery/GalleryManager";
import asyncify from "../../common/Asyncify";
const AsyncGalleryManager = asyncify(GalleryManager);
import ThemeContext from "@presto-contexts/ThemeContext";
import SectionHeader from "@presto-components/SectionHeaders/SectionHeader";
import useFocusEffect from "@presto-common/useFocusEffect";
import { VerticalSpacing } from "@presto-components/Spacing";
import I18n from "i18n-js";
import _ from "lodash";
import config from "@presto-common/config";
import SingleBannerSliders from "@presto-components/BannerSliders/SingleBannerSlider";
import utils from "../../utils";

export default function DealsComponent({
  navigation,
  title,
  fontStyle,
  fontSize,
  hideTitle,
  renderHeader,
  setItemCount,
  styles,
}) {
  const { theme } = useContext(ThemeContext);
  const [gallery, setGallery] = useState([]);
  const [galleryTitle, setGalleryTitle] = useState();
  const [currentIndex, setCurrentIndex] = useState(0);
  const windowWidth = Dimensions.get("window").width;
  let isDesktop = windowWidth > 940 ? true : false;
  const flatListRef = useRef(null);
  let isMobileWeb = utils.isMobileWeb();
  const { svgs, images } = useAssets();
  console.log(config.app, "vnfjvfjvbfbv");
  console.log(currentIndex, "hdudghbc");
  const getGallery = async (name) => {
    const [error, response] = await AsyncGalleryManager.getGallery({ name });
    if (response?.data && response?.data?.alternate_name != "") {
      setGalleryTitle(response?.data?.alternate_name);
    }
    setGallery(response?.data?.media_items);

    if (_.isFunction(setItemCount)) {
      let len = response?.data?.media_items?.length || 0;
      setItemCount(len);
    }
  };
  const offersList = gallery.map((img) => ({
    id: img.id,
    file_url: img.file_url,
  }));
  console.log(offersList, "ffgffhjjdgfresre");
  const handleScroll = (event) => {
    const scrollPosition = event.nativeEvent.contentOffset.x;
    const index = Math.round(scrollPosition / (windowWidth - 40));
    setCurrentIndex(index);
  };

  useFocusEffect(
    useCallback(() => {
      getGallery("BRANDS");
    }, [])
  );

  const renderItem = ({ item, index }) => {
    let widthSize = isMobileWeb ? 2 : 4;
    let heightSize = isMobileWeb ? 3.5 : 5.5;
    return (
      <TouchableWithoutFeedback>
        <ImageBackground
          style={{
            width: windowWidth / widthSize,
            height: (windowWidth - 25) / heightSize,
            borderRadius: 15,
            overflow: "hidden",
            // marginLeft: 22,
            margin: 10,
          }}
          source={{ uri: item.file_url }}
          resizeMode="contain"
        />
      </TouchableWithoutFeedback>
    );
  };
  if (_.isEmpty(gallery)) {
    return null;
  }
  return (
    <View
      style={{
        paddingVertical: theme.primaryPadding,
        marginBottom: 50,
      }}
    >
      {renderHeader ? renderHeader(galleryTitle) : null}
      {!hideTitle ? (
        <>
          <View
            style={{
              paddingHorizontal: theme.containerPadding,
              alignItems: "center",
              justifyContent: "space-between",
              flexDirection: "row",
            }}
          >
            <SectionHeader
              fontStyle={fontStyle}
              fontSize={fontSize}
              leftText={
                title ||
                galleryTitle ||
                (config.app === "simplyveggie"
                  ? "Brands We Deliver"
                  : I18n.t("screen_messages.testimonials.title"))
              }
            />
          </View>
          <VerticalSpacing size={10} />
        </>
      ) : null}

      {offersList?.length > 0 && (
        <View style={{ height: "100%" }}>
          <FlatList
            horizontal
            pagingEnabled
            keyExtractor={(_, index) => "index-" + index}
            data={gallery}
            renderItem={renderItem}
            swipeThreshold={10}
            layout={"default"}
            onScroll={handleScroll}
            ref={flatListRef}
            showsHorizontalScrollIndicator={false}
            contentContainerStyle={{
              paddingRight: theme.containerPadding,
            }}
          />
          <View style={activestyle.pagination}>
            {[...Array(Math.floor(offersList?.length / 4))].map((_, index) => (
              <View
                key={index}
                style={[
                  activestyle.dot,
                  currentIndex % Math.floor(offersList?.length / 4) === index
                    ? activestyle.activeDot
                    : activestyle.inactiveDot,
                ]}
              />
            ))}
          </View>
        </View>
      )}
    </View>
  );
}

const activestyle = StyleSheet.create({
  pagination: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    // marginTop: 8,
    // width: "100%",
  },
  dot: {
    height: 10,
    width: 10,
    borderRadius: 2.5,
    marginHorizontal: 3,
    backgroundColor: "gray",
    opacity: 0.6,
  },
  activeDot: {
    backgroundColor: "green",
    width: 10,
    height: 10,
    borderRadius: 3,
    opacity: 1,
  },
  inactiveDot: {
    backgroundColor: "gray",
    width: 5,
    height: 5,
    borderRadius: 2.5,
    opacity: 0.4,
  },
});
